import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import api from "../lib/api";
import { BookOpen, RefreshCw } from "lucide-react";

export default function Manual() {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api
      .get("/manual")
      .then((r) => setContent(r.data.content || ""))
      .catch(() => setContent("# Error\n\nNo se pudo cargar el manual."))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <div className="p-8 max-w-4xl" data-testid="manual-page">
      <div className="flex items-end justify-between gap-4 mb-8 flex-wrap">
        <div>
          <div className="font-mono-num text-[10px] uppercase tracking-[0.25em] text-[var(--ink-muted)] flex items-center gap-2">
            <BookOpen size={12} /> Documentación
          </div>
          <h1 className="font-display text-4xl font-black tracking-tight">Manual de uso.</h1>
          <p className="text-sm text-[var(--ink-muted)] mt-2 max-w-2xl">
            Estado actual del proyecto, cómo se usa cada sección y qué falta por completar.
          </p>
        </div>
        <button
          type="button"
          onClick={load}
          className="inline-flex items-center gap-2 border border-[var(--border)] bg-white px-3 py-2 text-xs hover:bg-[var(--hover)]"
          data-testid="manual-reload"
        >
          <RefreshCw size={12} /> Recargar
        </button>
      </div>

      {loading ? (
        <div className="text-sm text-[var(--ink-muted)] font-mono-num" data-testid="manual-loading">
          Cargando…
        </div>
      ) : (
        <article
          className="manual-prose bg-white border border-[var(--border)] p-8 text-[14px] leading-relaxed"
          data-testid="manual-content"
        >
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
        </article>
      )}
    </div>
  );
}
